/* XPOWER - Quita el naranja del tema.
   Todo texto naranja pasa a negro. Si esta sobre fondo oscuro, pasa a blanco.
   Ademas sube un poco el tamano de esos textos.
   El tema usa -webkit-text-fill-color, que manda sobre color: se cambian los dos.
   Esta hecho para no poner lenta la pagina: cada elemento se revisa una sola vez
   y el vigilante se apaga solo a los 12 segundos. */
(function(){
  'use strict';

  var MARCA = 'data-xp-tinta';
  var NEGRO = '#111111';
  var BLANCO = '#FFFFFF';

  function num(t){
    var n = 0, hay = false;
    for(var i = 0; i < t.length; i++){
      var c = t.charAt(i);
      if(c >= '0' && c <= '9'){ n = n * 10 + (c.charCodeAt(0) - 48); hay = true; }
      else if(hay){ break; }
    }
    return hay ? n : -1;
  }

  function trio(s){
    if(!s) return null;
    var abre = s.indexOf('(');
    if(abre < 0) return null;
    var partes = s.substring(abre + 1, s.length - 1).split(',');
    if(partes.length < 3) return null;
    var r = num(partes[0]), g = num(partes[1]), b = num(partes[2]);
    if(r < 0 || g < 0 || b < 0) return null;
    if(partes.length > 3 && parseFloat(partes[3]) === 0) return null;
    return [r, g, b];
  }

  function esNaranja(c){
    if(!c) return false;
    var r = c[0], g = c[1], b = c[2];
    return r >= 140 && (r - b) >= 55 && (r - g) >= 15 && g >= b;
  }

  function luz(c){ return (0.299 * c[0]) + (0.587 * c[1]) + (0.114 * c[2]); }

  function fondoDe(el){
    var n = el;
    while(n && n !== document.documentElement){
      var c = trio(window.getComputedStyle(n).backgroundColor);
      if(c) return c;
      n = n.parentElement;
    }
    return [255, 255, 255];
  }

  function tieneTextoPropio(el){
    for(var i = 0; i < el.childNodes.length; i++){
      var n = el.childNodes[i];
      if(n.nodeType === 3){
        var t = n.nodeValue;
        for(var j = 0; j < t.length; j++){ if(t.charAt(j) > ' ') return true; }
      }
    }
    return false;
  }

  function mayor(el, actual){
    var tag = el.tagName;
    var subir = 1;
    if(tag === 'H1' || tag === 'H2' || tag === 'H3' || tag === 'H4' || tag === 'H5' || tag === 'H6'){
      subir = Math.round(actual * 0.12);
      if(subir < 2) subir = 2;
      if(subir > 5) subir = 5;
    }
    return actual + subir;
  }

  function pintar(el, tono){
    el.style.setProperty('color', tono, 'important');
    el.style.setProperty('-webkit-text-fill-color', tono, 'important');
  }

  function revisar(el){
    if(!el || !el.tagName) return;
    if(el.getAttribute(MARCA)) return;
    var tag = el.tagName;
    if(tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'LINK' || tag === 'META') return;

    var st = window.getComputedStyle(el);
    if(!esNaranja(trio(st.webkitTextFillColor)) && !esNaranja(trio(st.color))) return;

    pintar(el, luz(fondoDe(el)) < 115 ? BLANCO : NEGRO);
    el.setAttribute(MARCA, '1');

    if(!tieneTextoPropio(el)) return;
    var px = parseFloat(st.fontSize);
    if(px > 0 && px < 34){
      el.style.setProperty('font-size', mayor(el, px) + 'px', 'important');
    }
  }

  function pasar(raiz){
    var base = raiz || document.body;
    if(base.nodeType !== 1) return;
    revisar(base);
    var hijos = base.querySelectorAll('*:not([' + MARCA + '])');
    for(var i = 0; i < hijos.length; i++){ revisar(hijos[i]); }
  }

  function arrancar(){
    pasar();
    setTimeout(function(){ pasar(); }, 800);
    setTimeout(function(){ pasar(); }, 2500);

    if(window.MutationObserver){
      var pendiente = [];
      var espera = null;
      var ojo = new MutationObserver(function(cambios){
        for(var i = 0; i < cambios.length; i++){
          var nuevos = cambios[i].addedNodes;
          for(var j = 0; j < nuevos.length; j++){
            if(nuevos[j].nodeType === 1) pendiente.push(nuevos[j]);
          }
        }
        if(!pendiente.length) return;
        if(espera) clearTimeout(espera);
        espera = setTimeout(function(){
          var lista = pendiente;
          pendiente = [];
          for(var k = 0; k < lista.length; k++){ pasar(lista[k]); }
        }, 200);
      });
      ojo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function(){ ojo.disconnect(); }, 12000);
    }

    document.addEventListener('mouseover', function(ev){
      var t = ev.target;
      if(!t || !t.tagName) return;
      setTimeout(function(){
        var st = window.getComputedStyle(t);
        if(esNaranja(trio(st.webkitTextFillColor)) || esNaranja(trio(st.color))){
          pintar(t, luz(fondoDe(t)) < 115 ? BLANCO : NEGRO);
        }
      }, 60);
    }, true);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();